import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m7 6.175 2.888-2.887.825.824L7.825 7l2.888 2.887-.825.825L7 7.825l-2.887 2.887-.825-.825L6.176 7 3.288 4.112l.825-.824z"
    }, null, -1)
  ]))]))
}
export default { render: render }